import React, { PureComponent } from 'react';

import * as topojson from 'topojson';

import {select as d3Select} from 'd3';
import * as d3Geo from 'd3-geo';


import './map.scss';

export default class DevicesMap extends PureComponent {
  constructor() {
    super();

    this.mapContainer = null;
    this.svg = null;
    this.width = 320;
    this.height = null;
    this.margin = {top: 0, right: 0, bottom: 0, left: 0};
    this.articles = {
      "Handfilter" : "einen",
      "Filterkaffeemaschine": "eine",
      "Padmaschine": "eine",
      "Kapselmaschine": "eine",
      "Siebstempelkanne": "eine",
      "Halbautomat": "einen",
      "Vollautomat": "einen",
      "Espressokanne": "eine"
    }
    this.rankingArray = null;
  }

  componentDidMount() {
    this.width = this.mapContainer.getBoundingClientRect().width - this.margin.left - this.margin.right;
    this.height = this.width * 1.25;

    const geojson = topojson.feature(this.props.geojson, this.props.geojson.objects['vg2500_bld']);
    const centroid = d3Geo.geoCentroid(geojson);

    const projection = d3Geo.geoMercator()
      .translate([this.width / 2, this.height/2])
      .center(centroid)
      .fitSize([this.width, this.height], geojson);

    const path = d3Geo.geoPath().projection(projection);

    this.updateRanking();
    this.createMap(projection, path, geojson);
  }

  componentDidUpdate() {
    this.updateRanking();
    this.updateMap();
  }

  createMap(projection, path, geojson) {

    this.svg = d3Select(this.refs.mapContainer)
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .attr('class', 'map')
      .append('g')
      .attr('transform', `translate(${this.margin.left}, ${this.margin.top})`);

    this.svg.selectAll('path')
      .data(geojson.features)
      .enter()
      .append('path')
      .classed('map-feature', true)
      .attr('d', path)
      .style('fill', "#fff")
      .attr("stroke", "#bbb");

    const that = this;

    const newData = Object.assign(...this.props.data.map( d => ({[d.Typ] : d})));

    const bubbles = this.svg.selectAll('.bubble')
      .data(geojson.features)
      .enter()
      .append('g')
      .classed('circle-wrapper', true)

    bubbles
      .append('circle')
      .classed('bubble', true)
      .attr('cx', d => projection([d.properties.LON, d.properties.LAT])[0])
      .attr('cy', d => projection([d.properties.LON, d.properties.LAT])[1])
      .datum(d => {
        return {
          val: parseFloat(newData[d.properties.ID][this.props.selectedDevice]),
          dev: this.props.selectedDevice,
          bl: d.properties.GEN,
          id: d.properties.ID,
          lat: d.properties.LAT,
          lon: d.properties.LON
        }
      })
      .attr('r', d => Math.sqrt(d.val/Math.PI) * window.config.shapes.circle_size)
      .style('fill', '#ACCA56')
      .style('fill-opacity', 0.5)
      .style('stroke', '#ACCA56');

    bubbles.append('text')
      .classed('ranking-label', true)
      .attr('x', d => projection([d.properties.LON, d.properties.LAT])[0])
      .attr('y', d => projection([d.properties.LON, d.properties.LAT])[1] + 4)
      .style('text-anchor', 'middle')
      .datum(d => d.properties.ID)
      .text( function(d){
        return `${that.rankingArray.map( x => x.bl).indexOf(d) + 1}.`;
      });

    bubbles
      .selectAll('circle')
      .on('mouseover', function(d) {
        const { val, bl, dev, lon, lat } = d;
        const radius = d3Select(this).attr('r');

        d3Select(that.refs.mapTooltip)
          .style('top', `${projection([lon, lat])[1]+Math.round(radius)+10}px`)
          .style('left', `${projection([lon, lat])[0]-75}px`)
          .html(`
            <div class="tt-val">
              ${(Math.round(val*10)/10).toLocaleString('de-DE')}%
            </div>
            <div class="tt-text">
              der Haushalte in ${bl} nutzen ${that.articles[dev]} ${dev}${dev === 'Vollautomat' || dev === 'Halbautomat' ? 'en' : ''}
            </div>
          `)
          .style('display', 'block');
      })
      .on('mousemove', () => {
        d3Select(this.refs.mapTooltip)
          .style('display', 'block');
      })
      .on('mouseout', () => {
        d3Select(this.refs.mapTooltip)
          .style('display', 'none');
      });
  }

  updateMap(){
    const newData = Object.assign(...this.props.data.map( d => ({[d.Typ] : d})));
    const that = this;

    this.svg.selectAll('.bubble')
      .datum(d => ({
        ...d,
        val: newData[d.id][this.props.selectedDevice],
        dev: this.props.selectedDevice
      }))
      .transition()
      .attr('r', d => Math.sqrt(d.val / Math.PI) * window.config.shapes.circle_size);

    this.svg.selectAll('.ranking-label')
    .text( function(d){
      return `${that.rankingArray.map( x => x.bl).indexOf(d) + 1}.`;
    });
  }

  updateRanking(){
    const rankingArray = this.props.data
      .filter( d => d.Typ !== 'gesamt')
      .map( d => ({ bl: d.Typ, val: d[this.props.selectedDevice]}));

    this.rankingArray = rankingArray.sort((a, b) => b.val - a.val);
  }

  render() {
    return (
      <div className="map-wrapper" ref={ref=> this.mapContainer = ref}>
        <svg ref="mapContainer" id="mapContainer"></svg>
        <div ref="mapTooltip" className="tooltip"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Component/DevicesMap/index.js